import { useIdentity } from '@vp/auth-react';
import { useContext, useState, useCallback, useEffect } from 'react';
import { API_ENDPOINTS } from './src-config-api-config.js';
import { useNRLogging } from './src-hooks-custom-hooks-useNRLogging.js';
import { CAContext } from './src-contexts-CAContext.js';

const useUserInfo = () => {
  const { logCustomAttributesNR } = useNRLogging();
  const { setChatState } = useContext(CAContext);
  const identity = useIdentity();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [toggle, setToggle] = useState(false);
  const trigger = useCallback(() => {
    setToggle(true);
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      if (toggle) {
        const identityObj = identity;
        const { authorizationHeader, isSignedIn } = identityObj;
        if (isSignedIn) {
          try {
            setLoading(true);
            logCustomAttributesNR("ca-chatbot-misc-api-request", {
              logLevel: "info",
              message: "Fetching user info",
              apiType: "getUserInfo"
            });
            const res = await fetch(API_ENDPOINTS.USER_PROFILE, {
              headers: {
                Accept: "application/json",
                Authorization: authorizationHeader
              }
            });
            if (!res.ok) {
              throw new Error(`Failed to fetch user profile: ${res.status} ${res.statusText}`);
            }
            const responseData = await res.json();
            setData({
              isLoggedIn: true,
              userData: {
                email: responseData.email,
                firstName: responseData.firstName,
                lastName: responseData.lastName,
                shopperId: responseData.canonicalId
              }
            });
            setChatState((prevState) => ({
              ...prevState,
              userInfo: {
                isLoggedIn: true,
                userData: {
                  email: responseData.email,
                  firstName: responseData.firstName,
                  lastName: responseData.lastName,
                  shopperId: responseData.canonicalId
                }
              }
            }));
          } catch (error2) {
            console.error(error2);
            logCustomAttributesNR("ca-chatbot-misc-api-error", {
              errorName: error2?.name,
              errorStack: error2?.stack,
              message: error2?.message,
              logLevel: "error",
              apiType: "getUserInfo"
            });
            setError(error2 instanceof Error ? error2 : new Error("Failed to fetch user info"));
            setData({ isLoggedIn: false });
          } finally {
            setLoading(false);
            setToggle(false);
          }
        } else {
          setData({ isLoggedIn: false });
          setToggle(false);
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [toggle]);
  return { data, loading, error, trigger };
};

export { useUserInfo };
//# sourceMappingURL=src-hooks-utility-hooks-useUserInfo.js.map
